import { FEATURE_FLAGS } from 'dashboard/featureFlags';

export const hasCostReportsAccess = (globalConfig, userId) => {
  const config = globalConfig || {};
  const allowedIds = config.costReportsAllowedUserIds || [];
  if (allowedIds.length) {
    return allowedIds.includes(Number(userId));
  }
  return !!config.costReportsEnabled;
};

export const hasWahaCampaignReportsAccess = (
  globalConfig,
  accountId,
  isFeatureEnabled
) => {
  const config = globalConfig || {};
  return (
    !!config.wahaEnabled &&
    !!config.wahaConfigured &&
    isFeatureEnabled(accountId, FEATURE_FLAGS.WAHA_CAMPAIGNS)
  );
};

export const isAccountFeatureEnabled = (accountFeatures, featureName) => {
  return !!accountFeatures?.[featureName];
};

export const isReportRouteAccessible = (route, routeContext = {}) => {
  const {
    accountId,
    accountFeatures = {},
    globalConfig = {},
    userId,
  } = routeContext;

  const { meta = {} } = route;
  const {
    featureFlag,
    requiresCostReports,
    requiresWahaCampaigns,
    requiresReports,
  } = meta;

  if (!requiresReports && !requiresCostReports && !requiresWahaCampaigns) {
    return true;
  }

  if (
    requiresReports &&
    !isAccountFeatureEnabled(accountFeatures, FEATURE_FLAGS.REPORTS)
  ) {
    return false;
  }

  if (featureFlag && !isAccountFeatureEnabled(accountFeatures, featureFlag)) {
    return false;
  }

  if (requiresCostReports && !hasCostReportsAccess(globalConfig, userId)) {
    return false;
  }

  if (
    requiresWahaCampaigns &&
    !hasWahaCampaignReportsAccess(globalConfig, accountId, (id, flag) =>
      isAccountFeatureEnabled(accountFeatures, flag)
    )
  ) {
    return false;
  }

  return true;
};
